import React, { useState, useEffect } from 'react'
import { filterBy } from '@progress/kendo-data-query'
import { Label } from '@progress/kendo-react-labels'
import { ComboBox } from '@progress/kendo-react-dropdowns'
import { loadMessages, LocalizationProvider } from '@progress/kendo-react-intl'

import './comboBox-template.css'
import TooltipHLPure from '../tooltipHL/tooltipHL.pure'
import LabelErrorPure from '../labelErrorPure/labelErrorPure'
import { LocalStorageService } from '../../../services'
import esMessages from './es.combobox'
import enMessages from './en.combobox'

const ComboBoxTemplatePure = (props) => {
  const {
    title,
    required,
    errorCombobox,
    errorMessage,
    tooltipShow,
    positionTooltip,
    titleTooltip,
    descriptionTooltip,
    subContent,
    restContent,
    informationIcon,
    allowCustom,
    data,
    placeholder,
    textField,
    dataItemKey,
    value,
    onChange,
    validityStyles,
    infoType,
  } = props

  const localStorageService = new LocalStorageService()
  const language =
    localStorageService.getLocalStorageItem('preferredLanguage') || 'es'

  // Helper to filter by infoType
  const filterByInfoType = (items, infoType) => {
    if (!infoType) return items
    if (infoType === 1) {
      return items.filter(item => item.infoType === `${process.env.REACT_APP_DIGITAL_VAULT_DOCUMENT}`) // Documento
    }
    if (infoType === 2) {
      return items.filter(item => item.infoType === `${process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE}`) // Expediente
    }
    return items
  }

  const [filteredData, setFilteredData] = useState(() => filterByInfoType(data, infoType))

  const filterChange = (event) => {
    const filter = event.filter
    // First filter by infoType, then by user input
    const infoTypeFiltered = filterByInfoType(data, infoType)
    setFilteredData(filterBy(infoTypeFiltered, filter))
  }

  useEffect(() => {
    setFilteredData(filterByInfoType(data, infoType))
  }, [data, infoType])

  useEffect(() => {
    setFilteredData(filterByInfoType(data, infoType))
    const messages = language === 'en' ? enMessages : esMessages
    loadMessages(messages, language)
  }, [data, infoType, language])

  // Style handlers for bug workaround:
  // This is a workaround for a bug in the Kendo ComboBox where the popup does not close properly after entering a not found input.
  const handleComboBoxClose = () => {
    const popup = document.querySelector('.k-animation-container.k-animation-container-relative.k-list-container.k-reset')
    if (popup) {
      popup.style.display = 'none'
    }
  }

  const handleComboBoxOpen = () => {
    const popup = document.querySelector('.k-animation-container.k-animation-container-relative.k-list-container.k-reset')
    if (popup) {
      popup.style.display = 'block'
    }
  }

  return (
    <div className='comboBoxTemplatePure-container'>
      <div className='comboBoxTemplatePure-label-container'>
        <Label className='label-tax-data'>
          {title}
          {required && ' *'}
        </Label>
        {tooltipShow && (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        )}
      </div>
      <LocalizationProvider language={language}>
        <ComboBox
          type='text'
          allowCustom={allowCustom}
          data={filteredData}
          dataItemKey={dataItemKey}
          filterable={true}
          onChange={onChange}
          onFilterChange={filterChange}
          onOpen={handleComboBoxOpen}
          onFocus={handleComboBoxOpen}
          onClose={handleComboBoxClose}
          placeholder={placeholder}
          textField={textField}
          validityStyles={validityStyles}
          value={value}
        />
      </LocalizationProvider>
      {errorCombobox && <LabelErrorPure label={errorMessage} />}
    </div>
  )
}

export { ComboBoxTemplatePure as default }
